import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CreationLoading from '../shared/CreationLoading';
import { useDApp, campaignAbi } from '../../contexts/web3';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import { useLanguage } from '../../contexts/LanguageContext';

const CampaignButtonCloseEarlyDialog = ({ campaign, onSuccess }) => {
  const [open, setOpen] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { web3, account, jwt } = useDApp();
  const { language, getLanguageContent } = useLanguage();
  const [content, setContent] = useState(
    getLanguageContent('CmpnBtnClsEarlyTrans')
  );

  useEffect(() => {
    setContent(getLanguageContent('CmpnBtnClsEarlyTrans'));
  }, [language]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    setLoading(true);
    setMsg(content.pleaseApprove);
    const contract = new web3.eth.Contract(
      campaignAbi,
      campaign.contractAddress
    );
    contract.methods
      .closeEarly()
      .send({ from: account })
      .once('transactionHash', (txHash) => {
        setMsg(content.closingEarly);
      })
      .once('confirmation', async (confNumber, receipt) => {
        if (receipt.status) {
          toast.success(content.closedEarly);
          //send out a put request to the server to update planEnd
          console.log(receipt);
          const details = await contract.methods.details().call();
          await fetch('/api/campaign/' + campaign.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + jwt,
            },
            body: JSON.stringify({
              planEnd: moment.unix(details.endTime).toDate(),
            }),
          });
          if (onSuccess) onSuccess();
        } else {
          toast.error(content.errorClosingEarly);
        }
        setLoading(false);
      })
      .once('error', (error, receipt) => {
        toast.error(error.message);
        setLoading(false);
      });
  };

  const myStyles = {
    marginLeft: '3px',
    marginRight: '3px',
    color: '#fff',
    background: 'green',
    letterSpacing: '1.2px',
    marginTop: '10px',
    marginBottom: '10px',
  };

  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        style={myStyles}
        onClick={handleClickOpen}
        className='campaign-buttons'
      >
        {content.closeEarly}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{content.ccEarly}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {content.closeEarlyText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            style={{ background: '#191970' }}
            onClick={handleClose}
          >
            {content.cancel}
          </Button>
          <Button
            variant='contained'
            style={{ background: 'darkorange' }}
            onClick={handleConfirm}
            autoFocus
          >
            {content.confirm}
          </Button>
        </DialogActions>
      </Dialog>
      {loading && <CreationLoading text={msg} />}
    </div>
  );
};

export default CampaignButtonCloseEarlyDialog;
